// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"SectionVisual-module-wrapper","image":"SectionVisual-module-image","withLottie":"SectionVisual-module-with-lottie","stagebox":"SectionVisual-module-stagebox"};